const module = { name: 'shared/utils/inputValidator', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const RegExes = {
    SYMBOL_OR_NUMBER: /[0-9,!@#$%^&*()|?:;+=".<>]+/,
    VALID_EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
    MSG_REPLACE: /{{name}}/gi,
}


const ValidationTypes = Object.freeze({
    CUSTOM: 'none',
    EMAIL: 'email',
    ZIP: 'zipCode'
})


const Presets = {
    [ValidationTypes.EMAIL]: {
        displayName: 'Email',
        passRules: [{
                regex: RegExes.VALID_EMAIL,
                msg: 'Please enter a valid email address.'
            }]
    },
    [ValidationTypes.ZIP]: {
        displayName: 'Postcode',
        passRules: [{
                regex: '^\\d{5}$|^\\d{5}-\\d{4}$',
                msg: 'Please enter a valid Postcode.'
            }]
    }
}
function applyRegExTests(value, tests, displayName, successCondition) {
    return tests
        .filter(rule => rule && rule.regex && rule.msg)
        .reduce((error, { regex, msg }) => {
        if (error) {
            return error;
        }
        regex = typeof regex === 'string' ? new RegExp(regex, 'i') : regex;
        return regex.test(value) === successCondition ? msg.replace(RegExes.MSG_REPLACE, displayName) : '';
    }, '');
}
function normalizeValidationRule(rule) {
    const $input = rule.$input || $(rule.input);
    const { type } = rule;
    let value = $.trim($input.val());
    if (type === ValidationTypes.EMAIL) {
        value = value.toLowerCase();
    }
    const preset = Presets[type] || {};
    const name = rule.name || $input.attr('name');
    return {
        $input,
        displayName: rule.displayName || preset.displayName || name || '',
        failRules: [].concat(preset.failRules, rule.failRules),
        isRequired: Boolean(typeof rule.isRequired === 'boolean' ? rule.isRequired : preset.isRequired),
        name: name || `unnamed-${Math.round(9999 * Math.random())}`,
        passRules: [].concat(preset.passRules, rule.passRules),
        value,
    };
}
function validate(validationRules) {
    const errors = [];
    const results = {};
    validationRules.forEach((rule) => {
        const { $input, displayName, failRules, isRequired, name, passRules, value } = normalizeValidationRule(rule);
        if (isRequired && !value) {
            return errors.push({
                $input,
                error: `${displayName} is required.`,
            });
        }
        let error;
        error = applyRegExTests(value, passRules, displayName, false);
        if (error) {
            return errors.push({ $input, error });
        }
        error = applyRegExTests(value, failRules, displayName, true);
        if (error) {
            return errors.push({ $input, error });
        }
        results[name] = value;
    });
    if (errors.length) {
        Object.assign(results, {
            hasErrors: true,
            errors,
        });
    }
    return results;
}
module.exports = {
    ValidationTypes,
    validate,
};
export default module.exports;